import { useQuery } from '@tanstack/react-query';
import { Alert, Button, Container } from 'react-bootstrap';
import { BsPencilSquare } from 'react-icons/bs';
import { LinkContainer } from 'react-router-bootstrap';
import { Outlet } from 'react-router-dom';
import { ProviderService } from '../../../api';
import { Card } from '../../../app/components/Card';
import { ProfileProgress } from '../../../app/components/ProfileProgress';
import { ProviderProfileHeader } from '../../../app/components/ProviderProfileHeader';
import { TabsNavbar } from '../../../app/components/TabsNavbar';
import { ProviderLimitContext } from '../../../app/contexts/ProviderLimitContext';
import { useCurrentUser } from '../../../app/hooks/auth';
import { useUserProgress } from '../../../app/hooks/user-progress';

export const CurrentProviderProfile = () => {
  const {
    isLoading: isProviderLoading,
    error: providerFetchError,
    data: provider,
  } = useQuery({
    queryKey: ['provider', 'detail', 'current'],
    queryFn: async () => await ProviderService.providerCurrentRetrieve(),
  });
  const { user } = useCurrentUser();
  const { progress, isProfileComplete } = useUserProgress(
    user?.provider_completed_registration_steps
  );

  const callToActionEdit = (
    <LinkContainer to="/app/provider/edit">
      <Button
        className="d-flex align-items-center justify-content-center px-3 py-2 mb-2 w-100"
        size="lg"
        variant="primary"
      >
        <BsPencilSquare className="me-2" /> Edit Profile
      </Button>
    </LinkContainer>
  );

  const callToActionComplete = (
    <div className="h-100 d-flex align-items-end justify-content-end">
      <div className="d-flex flex-column align-items-end pt-4">
        <ProfileProgress progress={progress} className="mx-auto mb-4" />
      </div>
    </div>
  );

  return (
    <>
      <div className="bg-primary-dark">
        <Container className="page-header-title mt-3" />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="bg-primary-dark d-block"
          style={{
            height: 'calc(3rem + 120px)',
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            zIndex: -10,
          }}
        />
        <Container>
          {!!providerFetchError && (
            <Alert variant="danger" show={!!providerFetchError}>
              <Alert.Heading>Something went wrong</Alert.Heading>
              <p>Please try again later. If the problem persists, please contact us.</p>
            </Alert>
          )}
          <ProviderProfileHeader
            provider={provider}
            isProviderLoading={isProviderLoading}
            isCurrentProvider
            isProfileComplete={isProfileComplete}
            callToAction={!isProfileComplete ? callToActionComplete : callToActionEdit}
          />
          <Card className="mb-4">
            <TabsNavbar
              alignment="center"
              tabs={[
                {
                  label: 'Calendar Overview',
                  to: '/app/provider/profile',
                },
                {
                  label: 'Credentials',
                  to: '/app/provider/profile/credentials',
                },
                {
                  label: 'Professional Traits',
                  to: '/app/provider/profile/professional-traits',
                },
                {
                  label: 'Education',
                  to: '/app/provider/profile/education',
                },
                {
                  label: 'Licenses & Certifications',
                  to: '/app/provider/profile/licenses',
                },
                // {
                //   label: 'Ratings',
                //   to: '/app/provider/profile/reputation',
                // },
                {
                  label: 'Other',
                  to: '/app/provider/profile/other',
                },
              ]}
            />
            <div className="pt-4 px-4">
              <ProviderLimitContext.Provider value={{ providerLimit: provider ?? null }}>
                <Outlet />
              </ProviderLimitContext.Provider>
            </div>
          </Card>
        </Container>
      </div>
      {/* <ProfileCompleteDialog provider={provider} show={true} closeDialog={() => {}}/> */}
    </>
  );
};
